import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { Observable } from 'rxjs';

import { User } from '../models/response/users/user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {}

  urlApiManagement = environment.urlApiManagement;

  getSetup() {
    const url = `${this.urlApiManagement}/api/v1/users/setups`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getSetup()')));
  }

  getUsers(): Observable<User[]> {
    const url = `${this.urlApiManagement}/api/v1/users`;
    return this.http.get<User[]>(url, {});
  }

  getUsersById(id: string): Observable<User> {
    const url = `${this.urlApiManagement}/api/v1/users/finds/${id}`;
    return this.http.get<User>(url, {});
  }

  getUsersByEmail(email: string) {
    const url = `${this.urlApiManagement}/api/v1/users/${email}/by`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getUsersByEmail()')));
  }

  getUserAccess(email: string | undefined) {
    const url = `${this.urlApiManagement}/api/v1/users/${email}/teams/access`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getUserAccess()')));
  }

  getUserRoleAccess(email: string | undefined) {
    const url = `${this.urlApiManagement}/api/v1/users/${email}/roles/access`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getUserRoleAccess()')));
  }

  getProfile(email: string | undefined) {
    const url = `${this.urlApiManagement}/api/v1/users/profiles/${email}`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getProfile()')));
  }

  deleteUsersById(id: string) {
    const url = `${this.urlApiManagement}/api/v1/users/${id}`;
    return this.http.delete(url, {}).pipe(catchError(this.handleError('deleteUsersById()')));
  }

  createUser(
    userName: string,
    shortName: string,
    countryId: number,
    countryName: string,
    emailAddress: string | undefined,
    createdBy: string,
    updatedBy: string
  ) {
    const url = `${this.urlApiManagement}/api/v1/users`;

    const body = {
      userId: Math.floor(Math.random() * 9999999),
      userName: userName,
      shortName: shortName,
      countryId: null,
      countryName: null,
      emailAddress: emailAddress,
      creationDate: moment(new Date(Date.now())).format('YYYY-MM-DD'),
      createdBy: '',
      updateDate: moment(new Date(Date.now())).format('YYYY-MM-DD'),
      updatedBy: '',
      statusFlag: 1
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('createUser()')));
  }

  updateUser(
    id: string,
    username: string,
    shortName: string,
    countryId: number,
    countryName: string,
    email: string,
    statusFlag: boolean
  ) {
    const url = `${this.urlApiManagement}/api/v1/users/${id}`;

    const body = {
      userId: id,
      userName: username,
      shortName: shortName,
      countryId: null,
      countryName: null,
      emailAddress: email,
      creationDate: moment(new Date(Date.now())).format('YYYY-MM-DD'),
      createdBy: '',
      updateDate: moment(new Date(Date.now())).format('YYYY-MM-DD'),
      updatedBy: '',
      statusFlag: statusFlag
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('updateUser()')));
  }

  updateUserStatus(id: string) {
    const url = `${this.urlApiManagement}/api/v1/users/status/${id}`;
    return this.http.post(url, {}).pipe(catchError(this.handleError('updateUserStatus()')));
  }

  processOwner(id: string) {
    const url = `${this.urlApiManagement}/api/v1/users/findBy/teamId/${id}`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('processOwner()')));
  }

  handleError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      return (error = error.rejection);
    }

    //this.zone.run(() =>
    // console.log('Message: ', error?.message,
    //     'Error: ', error?.status
    //  )
    //);

    return console.error('Error from global error handler', error);
  }
}
